<template>
  <div class="vz-light-order-step-footer">
    <div class="vz-light-order-step-footer-title">
      Шаг {{ lightOrderStep + 1 }} из 4
    </div>
    <div class="vz-light-order-step-footer-buttons">
      <vz-button
        v-if="lightOrderStep !== 0"
        big
        outline
        variant="primary"
        icon-name="arrow-left"
        @click="lightOrderStep--"
      >
        Назад
      </vz-button>
      <vz-button
        v-if="lightOrderStep !== 3"
        big
        variant="primary"
        icon-name="arrow-right"
        icon-right
        @click="next"
      >
        Далее
      </vz-button>
      <vz-button
        v-else
        big
        variant="primary"
        icon-name="arrow-right"
        icon-right
        @click="emit('send-form')"
      >
        Оформить заказ
      </vz-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import VzButton from '~/components/ui-kit/vz-button.vue';

const emit = defineEmits(['send-form'])

const { lightOrderStep } = storeToRefs(useOrderStore())
const validateOrderForm: Function = inject('validateOrderForm', () => {})

async function next() {
  if (await validateOrderForm()) {
    lightOrderStep.value++
  }
}
</script>

<style lang="scss" scoped>
.vz-light-order-step-footer {
  display: flex;
  column-gap: 32px;
  row-gap: 10px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 0;

  &-title {
    color: $font-lower;
    font-size: $fs-20;
    font-weight: 500;
    flex-shrink: 0;
  }

  &-buttons {
    display: flex;
    gap: 36px;
    justify-content: space-between;
    flex-grow: 1;

    .vz-button {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      font-size: 16px;

      &:first-child {
        max-width: calc((100% - 36px) * 0.4);
      }
      &:last-child {
        max-width: calc((100% - 36px) * 0.6);
        margin-left: auto;
      }
    }
  }

  @media screen and (max-width: $pub-md) {
    &-buttons {
      gap: 30px;
    }
  }

  @media screen and (max-width: $lg) {
    column-gap: 5px;
    &-buttons {
      gap: 5px;

      .vz-button {
        &:first-child {
          max-width: unset;
        }
        &:last-child {
          max-width: unset;
        }
      }
    }
  }

  @media screen and (max-width: $md) {
    row-gap: 20px;
    &-buttons {
      width: 100%;
      flex-wrap: wrap;
      row-gap: 10px;

      .vz-button {
        &:first-child, &:last-child {
          max-width: unset;
          width: 100%;
        }
      }
    }
  }
}
</style>
